import { Injectable } from '@angular/core';
import { StorageEnum } from 'src/models/others/StorageEnum';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor() { }

  public saveToken(userAccessToken: string,userRefreshToken:string): void {
    localStorage.setItem(StorageEnum.getUserAccessToken,userAccessToken);
    localStorage.setItem(StorageEnum.getUserRefreshToken,userRefreshToken);
  }
}
